import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Checkbox } from "@mui/material";

/**
 * Card used to select map layers (Ortofoto, NDVI).
 * Calls onLayerChange when a layer selection changes.
 * @params onLayerChange - function to select map layer
 */
export default function LayerCard({ layers, onLayerChange }) {
  return (
    <Card
      variant="outlined"
      sx={{
        m: 1,
        p: 1,
        width: "150px",
        backgroundColor: "background.tertiary",
        borderRadius: "10px",
        zIndex: 100
      }}
    >
      <CardContent>
        <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
          Layer
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
          <Checkbox
            checked={layers.ortofoto}
            onChange={() => onLayerChange?.("ortofoto")}
          />
          <Typography variant="body2">Ortofoto</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Checkbox
            checked={layers.ndvi}
            onChange={() => onLayerChange?.("ndvi")}
          />
          <Typography variant="body2">NDVI</Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
